import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

import Loading from "ui/Loading";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";
import { useFeature } from "providers/OrganizationFeatures";
import { useRoutes } from "utils/routes";

import OrganizationQueryDetails from "../OrganizationQueryDetails";

function QueryDetailsRoute() {
  const currentOrganization = useCurrentOrganization();
  const hasMergedQueries = useFeature("mergedQueries");
  const { organization } = useRoutes();
  const { fingerprint } = useParams();
  const [searchParams] = useSearchParams();
  const serverGroupId = searchParams.get("servergroup");
  const datname = searchParams.get("datname");

  if (!hasMergedQueries) {
    return <Navigate to={organization(currentOrganization.slug)} replace />;
  }

  if (Boolean(serverGroupId) !== Boolean(datname)) {
    return <Loading error />;
  }
  return (
    <OrganizationQueryDetails
      fingerprint={fingerprint}
      serverGroupId={serverGroupId || undefined}
      datname={datname || undefined}
    />
  );
}

export default QueryDetailsRoute;
